import styled from '@emotion/styled';
import { StyledButton, StyledInput } from '@selfserve/react-ui';
import { useEffect, useRef } from 'react';

interface Props {
  url?: string;
  requestType?: string;
  body?: {
    userKs?: string;
    userId?: string;
    ref?: string;
  };
  triggered: boolean;
}

export const StyledForm = styled.form(({ theme }: { theme?: any }) => ({
  visibility: 'hidden',
}));

export const KmeLoginPage = ({ url, requestType, body, triggered }: Props) => {
  const formRef = useRef<HTMLFormElement>(null);

  useEffect(() => {
    if (formRef.current && triggered) {
      formRef.current.submit();
    }
  }, [triggered]);

  return (
    <StyledForm
      ref={formRef}
      action={url as string}
      method={requestType as string}
    >
      <StyledInput id="userId" name="userId" value={body?.userId} />
      <StyledInput id="userKs" name="userKs" value={body?.userKs} />
      <StyledInput id="ref" name="ref" value={body?.ref} />
      <StyledButton type="submit">Continue</StyledButton>
    </StyledForm>
  );
};
